module.exports = __webpack_public_path__ + "assets/loop-preview-grid.8a77a602.svg";